import React from "react";
import BannerNotFound from "../../../assets/img/banner-notfound.png";
// import { FormattedMessage } from "react-intl";

const EmptyDashboardData = ({children}) => {
  return (
    <div className="empty-dashboard-data-container">
      <div><img src={BannerNotFound} alt="not found" /></div>
      {children}      
    </div>
  );
};

export default EmptyDashboardData;